module.exports = __webpack_public_path__ + "img/header-background.9a60985e.jpg";